/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Welcome_ParagraphInputs */



/**
* | output |
* | --- |
* | "AI that actually ships work. From your first chat to your whole organization: the strongest models, real automation, and EU AI Act and GDPR compliance built ..." |
*
* @param {Auth_Welcome_ParagraphInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_welcome_paragraph = /** @type {((inputs?: Auth_Welcome_ParagraphInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Welcome_ParagraphInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("KI, die wirklich liefert. Vom ersten Chat bis zur gesamten Organisation: die stärksten Modelle, echte Automatisierung und eingebaute Konformität mit EU-KI-Verordnung und DSGVO — von Tag eins an.")
	return /** @type {LocalizedString} */ ("AI that actually ships work. From your first chat to your whole organization: the strongest models, real automation, and EU AI Act and GDPR compliance built in from day one.")
});